<form class="section" [formGroup]="form">
  <div class="lna-input-row">
    <div class="label-wrapper">
      <label class="form-label" for="readingRoomId">
        {{ 'pages.service.visitRoom.readingRoomName' | translate }}
        <span class="required-field">*</span>
      </label>
      <app-tooltip text="chooseReadingRoomBackoffice" />
    </div>
    <select
      class="form-control"
      id="readingRoomId"
      [ngClass]="{ invalid: shouldRenderError('readingRoomId') }"
      formControlName="readingRoomId">
      <option [value]="null" disabled>
        {{ 'pages.service.visitRoom.selectReadingRoom' | translate }}
      </option>
      @for (option of readingRoomOptions; track option.value) {
        <option [value]="option.value">{{ option.label }}</option>
      }
    </select>
    @if (getErrorMessage('readingRoomId'); as errorMessage) {
      <div class="error-wrapper">
        <small class="error-message">
          {{ errorMessage | translate }}
        </small>
      </div>
    }
  </div>
  <div class="form-group inline-form-group">
    <div>
      <div class="label-wrapper">
        <label class="form-label" for="visitDate">
          {{ 'pages.service.visitRoom.visitDate' | translate }}
          <span class="required-field">*</span>
        </label>
        <app-tooltip text="visitDateFieldBackoffice" />
      </div>
      <app-date-picker
        [date]="visitDate?.value"
        [invalid]="shouldRenderError('visitDate')"
        [dateRangeMode]="dateRangeMode.All"
        (dateSelected)="onDateSelected($event, 'visitDate')" />
    </div>
    <div>
      <div class="label-wrapper">
        <label class="form-label" for="visitTimeFrom">
          {{ 'pages.service.visitRoom.visitTimeFrom' | translate }}
          <span class="required-field">*</span>
        </label>
        <app-tooltip text="visitTimeFromFieldBackoffice" />
      </div>
      <app-time-input
        [time]="visitTimeFrom?.value || ''"
        [invalid]="shouldRenderError('visitTimeFrom')"
        (timeChange)="onTimeChange($event, 'visitTimeFrom')"
        (blured)="markAsTouched('visitTimeFrom')" />
    </div>
    <div>
      <div class="label-wrapper">
        <label class="form-label" for="visitTimeTo">
          {{ 'pages.service.visitRoom.visitTimeTo' | translate }}
        </label>
        <app-tooltip text="visitTimeToFieldBackoffice" />
      </div>
      <app-time-input
        [time]="visitTimeTo?.value || ''"
        [invalid]="shouldRenderError('visitTimeTo')"
        [required]="false"
        (timeChange)="onTimeChange($event, 'visitTimeTo')"
        (blured)="markAsTouched('visitTimeTo')" />
    </div>
  </div>
  <div class="time-errors">
    <div class="error-wrapper">
      @if (getErrorMessage('visitDate'); as errorMessage) {
        <div class="error-wrapper">
          <small class="error-message">
            {{ errorMessage | translate }}
          </small>
        </div>
      }
      <div class="error-wrapper">
        @if (visitTimeFrom?.value === -1) {
          <div class="error-wrapper time-error">
            <small class="error-message">
              {{ 'pages.service.visitRoom.timeFormatErrorVisitTimeFrom' | translate }}
            </small>
          </div>
        } @else {
          @if (this.shouldRenderError('visitTimeFrom') && visitTimeFrom?.errors) {
            @if (visitTimeFrom?.errors?.['oneDayFromNow']) {
              <small class="error-message">
                {{ 'components.form.oneDayFromNow' | translate }}
              </small>
            }
          }
        }
      </div>
      @if (getErrorMessage('visitTimeFrom'); as errorMessage) {
        <div class="error-wrapper time-error">
          <small class="error-message">
            {{ errorMessage | translate }}
          </small>
        </div>
      }
      @if (visitTimeTo?.value === -1) {
        <div class="error-wrapper time-error">
          <small class="error-message">
            {{ 'pages.service.visitRoom.timeFormatErrorVisitTimeTo' | translate }}
          </small>
        </div>
      } @else {
        @if (this.shouldRenderError('visitTimeTo') && visitTimeTo?.errors) {
          @if (visitTimeTo?.errors?.['timeRangeError']) {
            <small class="error-message">
              {{ 'components.form.timeRangeError' | translate }}
            </small>
          }
        }
      }
    </div>
  </div>
  <div class="info-row">
    <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/info-blue.svg" />
    <p>{{ 'pages.service.visitRoom.info1' | translate }}</p>
  </div>
  <div class="info-row mb-40">
    <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/info-blue.svg" />
    <p>{{ 'pages.service.visitRoom.info2' | translate }}</p>
  </div>
  <div class="textarea-wrapper mb-40">
    <div class="label-wrapper">
      <label class="form-label" for="visitInformation">
        {{ 'pages.service.visitRoom.notes' | translate }}
      </label>
      <app-tooltip text="visitInformationFieldBackoffice" />
    </div>
    <textarea class="form-control" id="visitInformation" [maxlength]="maxFieldLength" formControlName="visitInformation"></textarea>
    <div class="textarea-error-wrapper">
      <p class="length" [ngClass]="{ invalid: visitInformation?.value.length > maxFieldLength }">
        {{ visitInformation?.value.length }}/{{ maxFieldLength }}
      </p>
      @if (getErrorMessage('visitInformation'); as errorMessage) {
        <div class="error-wrapper">
          <small class="error-message">
            {{ errorMessage | translate }}
          </small>
        </div>
      }
    </div>
  </div>
  <div class="checkbox-wrapper">
    <input
      class="form-check-input lna checkbox"
      id="agreementToReadingRoomTerms"
      type="checkbox"
      formControlName="agreementToReadingRoomTerms" />
    <label class="checkbox-label" [innerHTML]="'pages.service.visitRoom.acceptTerms' | translate" for="agreementToReadingRoomTerms"></label>
    <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/external-link-icon.svg" />
    @if (getErrorMessage('readingRoomId'); as errorMessage) {
      <div class="error-wrapper">
        <small class="error-message">
          {{ errorMessage | translate }}
        </small>
      </div>
    }
  </div>
</form>
<app-confirm-modal
  [isOpen]="isOpenConfirmBack"
  (confirm)="back(true)"
  (cancel)="isOpenConfirmBack = false"
  title="unsavedChanges"
  confirmText="continue"
  denyText="cancelBack" />
<app-confirm-modal
  [title]="'deleteReadingRoomSubmission'"
  [confirmText]="'delete'"
  [isOpen]="isOpenConfirmDeleteSubmission"
  (confirm)="deleteReadingRoomSubmission()"
  (cancel)="onModalClose()" />
<app-service-form-actions
  [isFirstStep]="true"
  [isNew]="!this.application"
  [showSaveDraft]="true"
  [isSubmitting]="isLoading"
  (exit)="back()"
  (saveDraft)="handleSaveDraft()"
  (deleteDraft)="handleDeleteDraft()"
  (continue)="submit()" />
